import { HelpCircle } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface FAQSectionProps {
  variant: "men" | "women";
}

const FAQSection = ({ variant }: FAQSectionProps) => {
  const isDark = variant === "women";
  
  const faqs = [
    {
      question: "לאיזה טווח גילאים השירות מתאים?",
      answer: "גילאי 25-55, כולל פרק ב׳. לכל שלב יש צרכים ייחודיים, ואנחנו מלווים גם את מי שמתחיל מחדש."
    },
    {
      question: "כמה אנשים יש במאגר?",
      answer: "איכות בלבד. 100% מהחברים עברו אימות, שילמו והתחייבו. כל פגישה היא עם מישהו שלקח אחריות."
    },
    {
      question: "האם המחשב מחליט על השידוכים?",
      answer: "לא. הטכנולוגיה מסייעת לזהות פוטנציאל. ההחלטה הסופית — תמיד אנושית."
    },
    {
      question: "תוך כמה זמן מקבלים הצעת שידוך?",
      answer: "האיפיון לוקח 2-3 שבועות. שידוך ראשון — כשיש התאמה אמיתית, לא לפני."
    },
    {
      question: "מה לגבי דיסקרטיות?",
      answer: "הפרופיל שלך פרטי לחלוטין. פרטים נחשפים רק אחרי אישור הדדי של המאמנים."
    }
  ];

  return (
    <section className={`py-20 md:py-32 ${isDark ? "bg-navy-light" : "bg-cream-dark"}`}>
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/20 mb-8">
            <HelpCircle className="w-8 h-8 text-gold" />
          </div>
          <h2 className={`font-serif text-3xl md:text-4xl lg:text-5xl font-bold ${isDark ? "text-cream" : "text-navy"}`}>
            שאלות נפוצות
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className={`rounded-xl px-6 border-0 ${
                  isDark 
                    ? "bg-navy border border-gold/10" 
                    : "bg-cream border border-gold/20"
                }`}
              >
                <AccordionTrigger 
                  className={`text-lg font-serif font-semibold hover:no-underline py-6 ${
                    isDark ? "text-cream hover:text-gold" : "text-navy hover:text-gold"
                  }`}
                >
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent 
                  className={`text-base leading-relaxed pb-6 ${
                    isDark ? "text-cream/70" : "text-muted-foreground"
                  }`}
                >
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;